module.exports = __webpack_public_path__ + "img/yjzk.cabaec56.svg";